/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoFssIcon20Regular = forwardRef('GovKoFssIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.75.75a.75.75 0 0 0-1.5 0v1.034a8.25 8.25 0 0 0 0 16.432v1.034a.75.75 0 0 0 1.5 0v-1.034a8.251 8.251 0 0 0 0-16.432V.75Zm-1.5 2.541a6.751 6.751 0 0 0 0 13.418V15.6a5.65 5.65 0 0 1 0-11.2V3.291Zm0 2.424a4.35 4.35 0 0 0 0 8.57V13.06a3.151 3.151 0 0 1 0-6.122V5.715Zm0 2.592a1.851 1.851 0 0 0 0 3.386V8.307Zm1.5 8.402V3.29a6.751 6.751 0 0 1 0 13.418Z" })));
});
